/**
 * Grobe Plausibilitäts-Prüfung der TLD, bevor CustomerLogo für eine gesetzte `website`
 * überhaupt ein Favicon abruft. Verhindert, dass offensichtlicher Test-/Eingabemüll
 * ("firma.fdsd", "sdfdsl.dsfa") ein zufälliges/unpassendes Icon von DuckDuckGo/Google
 * bekommt, statt sauber auf den grauen Platzhalter zurückzufallen — beides sind Favicon-
 * Dienste, die nicht zuverlässig 404 liefern.
 *
 * Bewusst eine Positivliste gängiger TLDs statt eine vollständige IANA-Liste — Ziel ist
 * NICHT hundertprozentige Korrektheit, sondern den konkret beobachteten Testmüll fernzuhalten,
 * ohne echte Kunden-Websites zu blockieren.
 */
const PLAUSIBLE_TLDS = new Set([
  'de', 'com', 'net', 'org', 'eu', 'info', 'biz', 'io', 'co', 'at', 'ch',
  'shop', 'online', 'digital', 'store', 'app', 'dev', 'me', 'tv', 'cc',
  'berlin', 'bayern', 'nrw', 'hamburg', 'koeln', 'muenchen', 'frankfurt',
  'uk', 'fr', 'it', 'es', 'nl', 'be', 'pl', 'cz', 'dk', 'se', 'no', 'fi',
  'space', 'group', 'gmbh',
]);

export function hasPlausibleTld(hostname: string | null | undefined): boolean {
  if (!hostname) return false;
  const parts = hostname.toLowerCase().split('.');
  const tld = parts[parts.length - 1];
  return !!tld && PLAUSIBLE_TLDS.has(tld);
}
